import { PlateViewerConfig } from '../models/plateViewerConfig';

export const PORSCHE_GT3_BANNER = {
  id: 199,
  url: 'https://cdn.platex.co.uk/large/porsche_gt3.png',
};
export const DEFAULT_IMAGE = {
  id: 100,
  url: 'https://cdn.platex.co.uk/large/DEFAULT_IMAGE.png',
};

export const BANNER_IMAGES = [DEFAULT_IMAGE, PORSCHE_GT3_BANNER];

export const DEFAULT_IMAGE_ID = 100;

const stored_configs: PlateViewerConfig[] = [
  {
    "id": 863,
    "carName": "BMW 1M ",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#252525\", \"scale\": {\"x\": 0.1245, \"y\": 0.1245, \"z\": 0.1245}, \"position\": {\"x\": 24.966888, \"y\": -17.952845, \"z\": 0.0}, \"rotation\": {\"_x\": 0.14503686, \"_y\": 0.4070108, \"_z\": -0.004712389, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/BMW1Mcopy.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "222d0c2b-7fa2-45b1-8788-3ba9690e13cd",
    "groupId": "bmw-1m-",
    "groupMain": true,
    "active": true,
  },
  {
    "id": 826,
    "carName": "Ferrari 458 Spyder",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#232323\", \"scale\": {\"x\": 0.128, \"y\": 0.128, \"z\": 0.128}, \"position\": {\"x\": 21.226715, \"y\": -22.460485, \"z\": 0.0}, \"rotation\": {\"_x\": 0.060737457, \"_y\": 0.07958701, \"_z\": -0.013962634, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/Ferrari458Spyder.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "d86deb3c-0734-4275-9cfd-41c22898ddcd",
    "groupId": "ferrari-458-spyder",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 727,
    "carName": "Ford Explorer",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#232323\", \"scale\": {\"x\": 0.121, \"y\": 0.121, \"z\": 0.121}, \"position\": {\"x\": 20.983845, \"y\": -7.1500506, \"z\": 0.0}, \"rotation\": {\"_x\": -0.036826447, \"_y\": 0.4511676, \"_z\": 0.042586032, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/ford_explorer_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "d1a93b01-e466-4262-8d64-d897ab21047c",
    "groupId": "ford_explorer_reduced",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 669,
    "carName": "Aston Martin DB12",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#1b1b1b\", \"scale\": {\"x\": 0.14, \"y\": 0.14, \"z\": 0.14}, \"position\": {\"x\": -19.332338, \"y\": -12.745743, \"z\": 0.0}, \"rotation\": {\"_x\": 0.08098327, \"_y\": -0.3159046, \"_z\": 0.018325957, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/db12_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "a6916de6-4456-4ff1-9b1d-51a2d5b98db7",
    "groupId": "db_12_reduced",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 668,
    "carName": "Aston Martin DBX",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#161616\", \"scale\": {\"x\": 0.1, \"y\": 0.1, \"z\": 0.1}, \"position\": {\"x\": -26.132658, \"y\": -14.2223835, \"z\": 0.0}, \"rotation\": {\"_x\": 0.039095376, \"_y\": -0.46216318, \"_z\": 0.028797932, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/dbx_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "90cf0e5d-801b-4f3c-b701-7de90250e0be",
    "groupId": "dbx_reduced",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 667,
    "carName": "Ferrari 250 GT PF",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#8d8d8d\", \"scale\": {\"x\": 0.113, \"y\": 0.113, \"z\": 0.113}, \"position\": {\"x\": -19.526632, \"y\": -19.351768, \"z\": 0.0}, \"rotation\": {\"_x\": -0.0026179939, \"_y\": -0.36826447, \"_z\": 0.007853982, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/250_gt_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "fc90baa6-769c-423e-bb5a-e5ec2f06df2d",
    "groupId": "250_gt",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 665,
    "carName": "Alpine A110R Ultime",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#191919\", \"scale\": {\"x\": 0.153, \"y\": 0.153, \"z\": 0.153}, \"position\": {\"x\": 30.941456, \"y\": -16.398485, \"z\": 0.0}, \"rotation\": {\"_x\": -0.023561945, \"_y\": 0.47787115, \"_z\": -0.0026179939, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/a110r_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "590060f5-77c5-41c5-bc67-d04be2bf320a",
    "groupId": "a1110r",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 664,
    "carName": "Alfa Romeo Giulia",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#1f1f1f\", \"scale\": {\"x\": 0.14, \"y\": 0.14, \"z\": 0.14}, \"position\": {\"x\": -9.229006, \"y\": -19.58492, \"z\": 0.0}, \"rotation\": {\"_x\": 0.0, \"_y\": -0.2846632, \"_z\": 0.0, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/giulia_gta_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "3d97205f-db1f-4e52-ab4b-e1bc726fc695",
    "groupId": "giulia_gta",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 662,
    "carName": "Ferrari 250 GT SWB",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#8d8d8d\", \"scale\": {\"x\": 0.12, \"y\": 0.12, \"z\": 0.12}, \"position\": {\"x\": -20.012371, \"y\": -28.755638, \"z\": 0.0}, \"rotation\": {\"_x\": 0.0, \"_y\": -0.34732053, \"_z\": 0.04956735, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/1962_250_GT_SWB_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "17ef92f5-3400-4d1f-b163-94b1c011a2c2",
    "groupId": "250_gt_swb",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 661,
    "carName": "Ferrari 250 GT Cabriolet",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#8d8d8d\", \"scale\": {\"x\": 0.125, \"y\": 0.125, \"z\": 0.125}, \"position\": {\"x\": -18.458012, \"y\": -25.646921, \"z\": 0.0}, \"rotation\": {\"_x\": 0.0, \"_y\": -0.22200587, \"_z\": 0.0, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/1958_250_GT_CAB_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "6748c6f1-5da6-419e-b0f8-71643823243b",
    "groupId": "250_gt_cab",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 504,
    "carName": "Tesla Cybertruck",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#232323\", \"scale\": {\"x\": 0.12, \"y\": 0.12, \"z\": 0.12}, \"position\": {\"x\": 18.263716, \"y\": -13.678358, \"z\": 0.0}, \"rotation\": {\"_x\": 0.0, \"_y\": 0.18011798, \"_z\": 0.0, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/CYBERTRUCK_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "7a1d5367-41f1-469b-a4b5-55d616be051d",
    "groupId": "cybertruck",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 503,
    "carName": "Porsche 718 Spyder",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#1f1f1f\", \"scale\": {\"x\": 0.11, \"y\": 0.11, \"z\": 0.11}, \"position\": {\"x\": -28.367048, \"y\": -21.450151, \"z\": 0.0}, \"rotation\": {\"_x\": -0.07417649, \"_y\": -0.34662238, \"_z\": 0.05305801, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/718_SPYDER_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "03fa43bb-102f-40eb-9fd2-de94442c2872",
    "groupId": "718_spyder",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 502,
    "carName": "Bentley Bentayga",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#101010\", \"scale\": {\"x\": 0.113, \"y\": 0.113, \"z\": 0.113}, \"position\": {\"x\": -26.861263, \"y\": -18.807743, \"z\": 0.0}, \"rotation\": {\"_x\": -0.041364305, \"_y\": -0.30176744, \"_z\": 0.009599311, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/BENTAYGA_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "eef22b13-97e0-4009-943e-605750764882",
    "groupId": "bentayga",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 501,
    "carName": "McLaren 675 LT",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.89)\", \"scale\": {\"x\": 0.09, \"y\": 0.09, \"z\": 0.09}, \"position\": {\"x\": 26.375526, \"y\": -18.652306, \"z\": 0.0}, \"rotation\": {\"_x\": 0.19076449, \"_y\": 0.12705997, \"_z\": -0.07417649, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/675_LT_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "3e207668-b590-4de1-8bf6-f3f908a4e982",
    "groupId": "675lt",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 500,
    "carName": "Lamborghini Murcialago",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#0c0c0c\", \"scale\": {\"x\": 0.11, \"y\": 0.11, \"z\": 0.11}, \"position\": {\"x\": -27.395575, \"y\": -21.450151, \"z\": 0.0}, \"rotation\": {\"_x\": 0.116588, \"_y\": -0.45553094, \"_z\": 0.05969026, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/MURCIALAGO_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "9c29db2e-d6ab-4631-b250-b4887f2d1be3",
    "groupId": "murcialago",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 499,
    "carName": "Land Rover Defender",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#181818\", \"scale\": {\"x\": 0.14, \"y\": 0.14, \"z\": 0.14}, \"position\": {\"x\": 19.08947, \"y\": -20.284384, \"z\": 0.0}, \"rotation\": {\"_x\": 0.08569567, \"_y\": 0.27576202, \"_z\": -0.0036651914, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/LR_DEFENDER_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "bcdfb102-0e00-4586-94a7-f90a37ec7a8c",
    "groupId": "lr_defender",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 498,
    "carName": "Bentley Continental GT",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#141414\", \"scale\": {\"x\": 0.116, \"y\": 0.116, \"z\": 0.116}, \"position\": {\"x\": 31.572914, \"y\": -21.91646, \"z\": 0.0}, \"rotation\": {\"_x\": 0.116588, \"_y\": 0.51923543, \"_z\": 0.021118484, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/CONTINENTAL_GT_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "a41200c8-559b-4057-9259-d8544b72f510",
    "groupId": "continental_gt",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 497,
    "carName": "Porsche 911 GT3 RS",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#181818\", \"scale\": {\"x\": 0.125, \"y\": 0.125, \"z\": 0.125}, \"position\": {\"x\": 35.118797, \"y\": -20.43982, \"z\": 0.0}, \"rotation\": {\"_x\": 0.16161749, \"_y\": 0.6688102, \"_z\": 0.090931654, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/GT3_RS_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "dba45af7-18ce-4fdc-8cc6-0a18564702ee",
    "groupId": "gt3rs",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 496,
    "carName": "Porsche 918",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#1b1b1b\", \"scale\": {\"x\": 0.117, \"y\": 0.117, \"z\": 0.117}, \"position\": {\"x\": 30.990028, \"y\": -26.501818, \"z\": 0.0}, \"rotation\": {\"_x\": 0.042411502, \"_y\": 0.48747045, \"_z\": -0.03176499, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/918_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "69e69eef-c0e4-4846-84a2-8445bb56e93a",
    "groupId": "918s",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 463,
    "carName": "Lamborghini Aventador S",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.91)\", \"scale\": {\"x\": 0.12, \"y\": 0.12, \"z\": 0.12}, \"position\": {\"x\": -28.075607, \"y\": -35.750256, \"z\": 0.0}, \"rotation\": {\"_x\": 0.0, \"_y\": -0.37507126, \"_z\": 0.0, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/AVENTADOR_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "db35d521-bf11-4062-a0b9-f92816c3772b",
    "groupId": "aventador",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 437,
    "carName": "Ferrari Roma",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.89)\", \"scale\": {\"x\": 0.115, \"y\": 0.115, \"z\": 0.115}, \"position\": {\"x\": -26.132658, \"y\": -22.69364, \"z\": 0.0}, \"rotation\": {\"_x\": -0.030543262, \"_y\": -0.33527774, \"_z\": -0.04712389, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/ROMA_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "38fc4054-764a-4567-ac4c-b13c5d83846e",
    "groupId": "roma",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 436,
    "carName": "Heritage Customs Defender",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.91)\", \"scale\": {\"x\": 0.096, \"y\": 0.096, \"z\": 0.096}, \"position\": {\"x\": -23.898268, \"y\": -24.714306, \"z\": 0.0}, \"rotation\": {\"_x\": 0.022340214, \"_y\": -0.315381, \"_z\": 0.04223697, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/DEFENDER_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "45a58b91-3208-4ece-be4f-1f227dfecba5",
    "groupId": "defender",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 435,
    "carName": "Ferrari 488 Pista",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.78)\", \"scale\": {\"x\": 0.113, \"y\": 0.113, \"z\": 0.113}, \"position\": {\"x\": 31.670061, \"y\": -23.937126, \"z\": 0.0}, \"rotation\": {\"_x\": 0.3700098, \"_y\": 0.6084218, \"_z\": -0.057072267, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/F8_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "f74c2464-ab49-4cf7-8111-f79b194c4ae6",
    "groupId": "f8",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 434,
    "carName": "Fiat 500 Riva",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#272727\", \"scale\": {\"x\": 0.12, \"y\": 0.12, \"z\": 0.12}, \"position\": {\"x\": 29.338524, \"y\": -5.67341, \"z\": 0.0}, \"rotation\": {\"_x\": -0.33283427, \"_y\": 0.60545474, \"_z\": 0.19966567, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/FIAT_500_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "c0026e9c-e29d-49b0-9c98-bb4b814500ad",
    "groupId": "fiat_500",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 433,
    "carName": "Ferrari Testarossa",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.87)\", \"scale\": {\"x\": 0.076, \"y\": 0.076, \"z\": 0.076}, \"position\": {\"x\": 32.544388, \"y\": -32.330666, \"z\": 0.0}, \"rotation\": {\"_x\": -0.06702064, \"_y\": 0.41975167, \"_z\": -0.037175514, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/TESTAROSSA_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "ec7d2677-4237-4ce5-85f1-b35ce70d9550",
    "groupId": "testarossa",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 432,
    "carName": "Ferrari 488 Pista",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.92)\", \"scale\": {\"x\": 0.12, \"y\": 0.12, \"z\": 0.12}, \"position\": {\"x\": 25.452627, \"y\": -17.564255, \"z\": 0.0}, \"rotation\": {\"_x\": 0.25080383, \"_y\": 0.41975167, \"_z\": -0.10681415, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/PISTA_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "4f45b11e-aefa-4fd9-9636-1a7ac0fa40f0",
    "groupId": "pista",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 431,
    "carName": "Mercedes G Wagon",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.88)\", \"scale\": {\"x\": 0.163, \"y\": 0.163, \"z\": 0.163}, \"position\": {\"x\": -17.340816, \"y\": -15.154999, \"z\": 0.0}, \"rotation\": {\"_x\": 0.032288592, \"_y\": -0.30543262, \"_z\": 0.022340214, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/GWAGON_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "0af4d751-429a-4d8e-b59f-7745511026a7",
    "groupId": "g_wagon",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 430,
    "carName": "Porsche Turbo S",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.98)\", \"scale\": {\"x\": 0.125, \"y\": 0.125, \"z\": 0.125}, \"position\": {\"x\": 28.755638, \"y\": -15.699024, \"z\": 0.0}, \"rotation\": {\"_x\": 0.052185345, \"_y\": 0.47839475, \"_z\": 0.012391837, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/TURBO_S_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "8f3647ad-d8d9-464d-b310-d1fc5c151c52",
    "groupId": "turbo_s",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 406,
    "carName": "Mercedes G-Wagon 6X6",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#1b1b1b\", \"scale\": {\"x\": 0.0845, \"y\": 0.0845, \"z\": 0.0845}, \"position\": {\"x\": -30.067131, \"y\": -14.610971, \"z\": 0.0}, \"rotation\": {\"_x\": -0.0034906585, \"_y\": -0.42044982, \"_z\": 0.0034906585, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/GWAGON_6X6_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "028cfdd2-4dd3-4f9b-be0d-0df7e4249e3e",
    "groupId": "gwagon_6x6",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 405,
    "carName": "Lamborghini Urus Performante",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(24,24,24,0.95)\", \"scale\": {\"x\": 0.126, \"y\": 0.126, \"z\": 0.126}, \"position\": {\"x\": 24.5, \"y\": -24.0, \"z\": 0.0}, \"rotation\": {\"_x\": 0.010646508, \"_y\": 0.22218041, \"_z\": -0.0034906585, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/URUS_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "975654b8-9a79-47b9-9ff8-23eac84996b6",
    "groupId": "lamborghini_urus",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 404,
    "carName": "Rolls Royce Spectre",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.85)\", \"scale\": {\"x\": 0.147, \"y\": 0.147, \"z\": 0.147}, \"position\": {\"x\": -24.183525, \"y\": -20.113665, \"z\": 0.0}, \"rotation\": {\"_x\": 0.116588, \"_y\": -0.42044982, \"_z\": 0.010646508, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/RR_WRAITH_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "759e50c9-532a-431d-a0f0-6c4d2a6f77f0",
    "groupId": "rr_wraith",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 403,
    "carName": "Rolls Royce Cullinan",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.87)\", \"scale\": {\"x\": 0.143, \"y\": 0.143, \"z\": 0.143}, \"position\": {\"x\": 28.561344, \"y\": -16.009895, \"z\": 0.0}, \"rotation\": {\"_x\": -0.07400196, \"_y\": 0.5464626, \"_z\": -0.017627826, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/RR_CULLINAN_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "6d341355-76f4-4ff9-8366-2810f85b9cb7",
    "groupId": "rr_cullinan",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 402,
    "carName": "McLaren P1",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#302f30\", \"scale\": {\"x\": 0.127, \"y\": 0.127, \"z\": 0.127}, \"position\": {\"x\": 25.622635, \"y\": -30.23228, \"z\": 0.0}, \"rotation\": {\"_x\": -0.04590216, \"_y\": 0.34906584, \"_z\": -0.0034906585, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/P1_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "a8653ffa-eca6-45bd-8e47-e08aac26993d",
    "groupId": "mclaren_p1",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 401,
    "carName": "Ferrari LaFerrari",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.8)\", \"scale\": {\"x\": 0.118, \"y\": 0.118, \"z\": 0.118}, \"position\": {\"x\": -10.905145, \"y\": -25.491486, \"z\": 0.0}, \"rotation\": {\"_x\": -0.2432989, \"_y\": -0.25743607, \"_z\": 0.08115781, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/LAF_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "3105063f-0852-4ee5-99d7-da7e210c7073",
    "groupId": "ferrari_la_ferrari",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 399,
    "carName": "Ferrari F12 TRS",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(21,21,21,0.89)\", \"scale\": {\"x\": 0.143, \"y\": 0.143, \"z\": 0.143}, \"position\": {\"x\": 13.279872, \"y\": -18.036385, \"z\": 0.0}, \"rotation\": {\"_x\": -0.24085544, \"_y\": 0.17627825, \"_z\": -0.017627826, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/F12_TRS_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "bb9d8159-8398-450b-901d-4ff7aa3e30bd",
    "groupId": "f12_trs",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 398,
    "carName": "Lamborghini Countach",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.85)\", \"scale\": {\"x\": 0.108, \"y\": 0.108, \"z\": 0.108}, \"position\": {\"x\": -21.663877, \"y\": -33.185562, \"z\": 0.0}, \"rotation\": {\"_x\": -0.15865043, \"_y\": -0.29967302, \"_z\": 0.052883476, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/COUNTACH_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "6c99148f-9888-4f68-8767-7608f837adae",
    "groupId": "lamborghini_countach",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 397,
    "carName": "Mercedes AMG GTR",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"rgba(0,0,0,0.88)\", \"scale\": {\"x\": 0.128, \"y\": 0.128, \"z\": 0.128}, \"position\": {\"x\": 21.761024, \"y\": -26.4241, \"z\": 0.0}, \"rotation\": {\"_x\": 0.0, \"_y\": 0.39130282, \"_z\": -0.017627826, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/AMG_GTR_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "36ecf48f-bca0-4323-bb76-fa9836d3ac5b",
    "groupId": "mercedes_amg_gtr",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 371,
    "carName": "Audi RS5",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#0d0d0d\", \"scale\": {\"x\": 0.13, \"y\": 0.13, \"z\": 0.13}, \"position\": {\"x\": -21.178139, \"y\": -10.802794, \"z\": 0.0}, \"rotation\": {\"_x\": -0.002443461, \"_y\": -0.45867252, \"_z\": -0.030019663, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/RS5_Reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "63d4d91a-f39b-4bb1-beb1-3fab2cf39038",
    "groupId": "reduced",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 370,
    "carName": "Audi RS3",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#0f0f0f\", \"scale\": {\"x\": 0.105, \"y\": 0.105, \"z\": 0.105}, \"position\": {\"x\": -16.903652, \"y\": -10.336485, \"z\": 0.0}, \"rotation\": {\"_x\": -0.0038397245, \"_y\": -0.48677233, \"_z\": 0.0068067843, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/RS3_Reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "e5844aaf-cb72-4c9b-a07b-b3b7608b7945",
    "groupId": "reduced",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 367,
    "carName": "BMW M8 Competition",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#1a1616\", \"scale\": {\"x\": 0.138, \"y\": 0.138, \"z\": 0.138}, \"position\": {\"x\": -23.849691, \"y\": -16.087612, \"z\": 0.0}, \"rotation\": {\"_x\": 0.031066861, \"_y\": -0.43109632, \"_z\": 0.024085544, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/BMW2_Reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "9ae8eb7c-bdf8-425d-b19b-2e5bfdee92f3",
    "groupId": "reduced",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 366,
    "carName": "BMW M3 Competition",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#0c0c0c\", \"scale\": {\"x\": 0.15, \"y\": 0.15, \"z\": 0.15}, \"position\": {\"x\": -13.649214, \"y\": -14.455538, \"z\": 0.0}, \"rotation\": {\"_x\": 0.0, \"_y\": -0.3551745, \"_z\": 0.0, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/BMW_Reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "5d7b4048-1258-491a-82a7-9f8bc1e27db4",
    "groupId": "reduced",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 364,
    "carName": "Alpine A110S",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#171414\", \"scale\": {\"x\": 0.096, \"y\": 0.096, \"z\": 0.096}, \"position\": {\"x\": -19.623781, \"y\": -10.802794, \"z\": 0.0}, \"rotation\": {\"_x\": -0.12077679, \"_y\": -0.65118235, \"_z\": 0.031066861, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/ALPINE_Reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "e1c86d4e-f252-4245-bda8-bc939bfef9c6",
    "groupId": "reduced",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 301,
    "carName": "BMW Z4 M40i",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#1b1818\", \"scale\": {\"x\": 0.15, \"y\": 0.15, \"z\": 0.15}, \"position\": {\"x\": -21.275288, \"y\": -14.300101, \"z\": 0.0}, \"rotation\": {\"_x\": 0.05009095, \"_y\": -0.41381755, \"_z\": 0.012566371, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/Z4_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "876c6a8d-4196-4505-bd3d-6df6b80c3624",
    "groupId": "reduced_z4",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 300,
    "carName": "Mini Cooper S",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#100f0f\", \"scale\": {\"x\": 0.138, \"y\": 0.138, \"z\": 0.138}, \"position\": {\"x\": 19.818075, \"y\": -9.947897, \"z\": 0.0}, \"rotation\": {\"_x\": -0.12548918, \"_y\": 0.38885936, \"_z\": -0.03769911, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/JCW_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "2ac16ca7-7810-439c-8710-90a6a682c32a",
    "groupId": "reduced_cooper",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 299,
    "carName": "Rolls-Royce Wraith",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#272525\", \"scale\": {\"x\": 0.105, \"y\": 0.105, \"z\": 0.105}, \"position\": {\"x\": 11.754839, \"y\": -13.367486, \"z\": 0.0}, \"rotation\": {\"_x\": -0.17558013, \"_y\": 0.42638394, \"_z\": -0.03769911, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/wraith_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "e77fb197-ee05-45e8-a045-047d9d501875",
    "groupId": "reduced_wraith",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 298,
    "carName": "BMW I8",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#1b1919\", \"scale\": {\"x\": 0.125, \"y\": 0.125, \"z\": 0.125}, \"position\": {\"x\": -24.286858, \"y\": -22.538204, \"z\": 0.0}, \"rotation\": {\"_x\": -0.01308997, \"_y\": -0.38048178, \"_z\": 0.01308997, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/i8_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "a29eee01-9db4-4b9d-91e9-d44d84367a42",
    "groupId": "reduced_i8",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  },
  {
    "id": 265,
    "carName": "Lamborghini Huracan EVO",
    "config": "{\"name\": \"NEW-CONFIG\", \"config\": {\"textInfo\": {\"color\": \"#161414\", \"scale\": {\"x\": 0.133, \"y\": 0.133, \"z\": 0.133}, \"position\": {\"x\": 21.955318, \"y\": -5.440256, \"z\": 0.0}, \"rotation\": {\"_x\": -0.078016214, \"_y\": 0.4680973, \"_z\": -0.013439035, \"_order\": \"XYZ\"}}, \"imageInfo\": {\"path\": \"https://cdn.platex.co.uk/plate-viewer/EVO_reduced.png\", \"_width\": 1920.0, \"_height\": 1200.0}}}",
    "imageName": "aa2183ec-8e96-4ced-bf0c-0343f2c9515e",
    "groupId": "evo",
    "groupMain": true,
    "active": true,
    "ebay_only": false,
    "premium": false
  }
].map(r => {
    return {
      'id': r.id,
      'carName': r.carName,
      'imageName': r.imageName,
      'groupId': r.groupId,
      'groupMain': r.groupMain,
      'active': r.active,
      'config': r.config,//JSON.parse(r.config)
    } as PlateViewerConfig;
  });


  const legacy_stored_configs: PlateViewerConfig[] = [
  new PlateViewerConfig({
    carName: 'Lamborghini Huracan Evo',
    config: JSON.stringify({
      name: 'NEW-CONFIG',
      config: {
        textInfo: {
          color: '#1b1616',
          scale: {
            x: 0.1355,
            y: 0.1355,
            z: 0.1355,
          },
          position: {
            x: 21.955318,
            y: -5.440256,
            z: 0,
          },
          rotation: {
            _x: -0.078016214,
            _y: 0.38501963,
            _z: -0.013439035,
            _order: 'XYZ',
          },
        },
        imageInfo: {
          path: 'https://cdn.platex.co.uk/plate-viewer/EVO_reduced.png',
          _width: 1920,
          _height: 1200,
        },
      },
    }),
    groupId: '265',
    id: 265,
    imageName: '6eade87d-ba0c-4fa0-9685-e67a97766060',
    active: true,
  }),
  new PlateViewerConfig({
    id: 369,
    carName: 'Audi R8 V10 RWD',
    config:
      '{"name": "NEW-CONFIG", "config": {"textInfo": {"color": "#0d0c0c", "scale": {"x": 0.098, "y": 0.098, "z": 0.098}, "position": {"x": 17.680832, "y": -11.113666, "z": 0.0}, "rotation": {"_x": -0.059515726, "_y": 0.4654793, "_z": 0.009424778, "_order": "XYZ"}}, "imageInfo": {"path": "https://cdn.platex.co.uk/plate-viewer/R8_Reduced.png", "_width": 1920.0, "_height": 1200.0}}}',
    imageName: '6cd3f1c4-f4fa-40da-b306-04e8a117bd7a',
    groupId: 'reduced',
    active: true,
  }),
  // new PlateViewerConfig({
  //   id: 368,
  //   carName: 'Jaguar F-Type R',
  //   config:
  //     '{"name": "NEW-CONFIG", "config": {"textInfo": {"color": "#110f0f", "scale": {"x": 0.09, "y": 0.09, "z": 0.09}, "position": {"x": 13.1149025, "y": -17.02023, "z": 0.0}, "rotation": {"_x": 0.0, "_y": 0.40561453, "_z": 0.0, "_order": "XYZ"}}, "imageInfo": {"path": "https://cdn.platex.co.uk/plate-viewer/FTYPE_Reduced.png", "_width": 1920.0, "_height": 1200.0}}}',
  //   imageName: '41526600-5b16-490e-ae62-70500d140513',
  //   groupId: 'reduced',
  //   active: true,
  // }),
  new PlateViewerConfig({
    id: 300,
    carName: 'Mini Cooper S',
    config:
      '{"name": "NEW-CONFIG", "config": {"textInfo": {"color": "#100f0f", "scale": {"x": 0.138, "y": 0.138, "z": 0.138}, "position": {"x": 19.818075, "y": -9.947897, "z": 0.0}, "rotation": {"_x": -0.12548918, "_y": 0.38885936, "_z": -0.03769911, "_order": "XYZ"}}, "imageInfo": {"path": "https://cdn.platex.co.uk/plate-viewer/JCW_reduced.png", "_width": 1920.0, "_height": 1200.0}}}',
    imageName: '2ac16ca7-7810-439c-8710-90a6a682c32a',
    groupId: 'reduced_cooper',
    active: true,
  }),
  // new PlateViewerConfig({
  //   id: 694,
  //   carName: `Santa's Sleigh`,
  //   config: `{"name": "NEW-CONFIG", "config": {"textInfo": {"color": "#232323", "scale": {"x": 0.11, "y": 0.11, "z": 0.11}, "position": {"x": -11.074807, "y": -12.357153, "z": 0.0}, "rotation": {"_x": 0.29112092, "_y": -0.19634955, "_z": 0.06091199, "_order": "XYZ"}}, "imageInfo": {"path": "https://cdn.platex.co.uk/plate-viewer/santa_reduced.png", "_width": 1920.0, "_height": 1200.0}}}`,
  //   imageName: '5f896092-828b-4882-aa4b-0509820a62f4',
  //   groupId: 'christmas',
  //   active: true,
  // }),
];

// QUICKLOAD CONFIG - PLATE VIEWER
const configId = () => {
  const randomId = Math.floor(Math.random() * stored_configs.length);
  return randomId;
};
export const quick_config: PlateViewerConfig = stored_configs[configId()];

//"https://cdn.platex.co.uk/plate-viewer/NoPath---Copy-(16).jpg"

export const SITE_BANNER_IMAGES = {
  ASTON_DB11: 'https://cdn.platex.co.uk/large/S34RCH_ASTON_DB11.png',
  FERRARI_F40: 'https://cdn.platex.co.uk/large/S3LLS_FERRARI_F40.png',
  FERRARI_275: 'https://cdn.platex.co.uk/large/8UYS_FERRARI_275.png',
  FERRARI_275_MB:
    'https://cdn.platex.co.uk/banners/8UYS_FERRARI_275_BANNER_MB.png',
  RR_DEFENDER: 'https://cdn.platex.co.uk/large/DE51GNS_RANGEROVER_DEFENDER.png',
  RR_DEFENDER_MB:
    'https://cdn.platex.co.uk/banners/DE51GNS_RANGEROVER_DEFENDER_BANNER_MB.png',
  LAMBORGHINI_DIABLO:
    'https://cdn.platex.co.uk/large/L5_LAMBORGHINI_DIABLO.png',
  LAMBORGHINI_DIABLO_MB:
    'https://cdn.platex.co.uk/banners/L5_LAMBORGHINI_DIABLO_BANNER_MB.png',
  PORSCHE_TAYCAN: 'https://cdn.platex.co.uk/large/PAY135S_PORSCHE_TAYCAN.png',
  MINI_JCW: 'https://cdn.platex.co.uk/large/HO72ODS_MINI_JCW.png',
  BMW_M2: 'https://cdn.platex.co.uk/large/8UYS_BMW_M2.png',
  PORSCHE_GT3: 'https://cdn.platex.co.uk/large/AUC710N_PORSCHE_GT3.png',
  BUGATTI_STREET: 'https://cdn.platex.co.uk/large/BUGATTI_CHIRON_STREET.jpg',
  BUGATTI_TRACK: 'https://cdn.platex.co.uk/large/BUGATTI_CHIRON_TRACK.jpg',
  //
  _BUGGATI: 'https://cdn.platex.co.uk/large/BUGATTI_IMAGE.jpg',
  _GT3RS: 'https://cdn.platex.co.uk/large/porsche%20gt3%20rs.jpg',
  _FERRARI: 'https://cdn.platex.co.uk/large/FERRARI_TDF.jpg',
  COUNTACH: 'https://cdn.platex.co.uk/large/Sell-Countach.png',
  AVENTADOR_S: 'https://cdn.platex.co.uk/large/AVENTADOR_S.png',
  PORSCHE_918: 'https://cdn.platex.co.uk/large/PORSCHE_918.png',

  AVENTADOR_S_FOOTER: 'https://cdn.platex.co.uk/pages/AVS_FOOTER.png',
  SELLING_F40: 'https://cdn.platex.co.uk/pages/sell-landing/FERRARI_S3LLS.png',
  PORSCHE_918_S:
    'https://cdn.platex.co.uk/pages/blog-landing/PORSCHE_918_SPYDER.png',
  FERRARI_812: 'https://cdn.platex.co.uk/pages/name-search/812_FERRARI.png',
  DIABLO_GT: 'https://cdn.platex.co.uk/pages/compare/DIABLO_GT.png',

  LANDING_918: 'https://cdn.platex.co.uk/pages/landing/PORSCHE_918_v2.png',
  LANDING_918_MB:
    'https://cdn.platex.co.uk/pages/landing/PORSCHE_918_MB_v2.png',
  SELL_992_TURBO: 'https://cdn.platex.co.uk/pages/landing/992_TURBO_v2.png',
  SELL_992_TURBO_MB:
    'https://cdn.platex.co.uk/pages/landing/992_TURBO_MB_v4.png',

  // new release
  CURATED_MURCI: 'https://cdn.platex.co.uk/pages/new-release/CURATED_MURCI.png',
  CURATED_MURCI_MB:
    'https://cdn.platex.co.uk/pages/new-release/CURATED_MURCI_MB.png',
  ATTACKS_P1: 'https://cdn.platex.co.uk/pages/new-release/ATTACKS_P1.png',
  ATTACKS_P1_MB: 'https://cdn.platex.co.uk/pages/new-release/ATTACKS_P1_MB.png',
  JAMES_RR: 'https://cdn.platex.co.uk/pages/name-search/JAMES_RR.png',
  JAMES_RR_MB: 'https://cdn.platex.co.uk/banners/JAMES_RR_MB.png',

  // 25
  BERSERK_AMG: 'https://cdn.platex.co.uk/pages/new-release/BERSERK_AMG.png',
  BERSERK_AMG_MB:
    'https://cdn.platex.co.uk/pages/new-release/BERSERK_AMG_MB.png',

  // 26
  LA26EST_AMG: 'https://cdn.platex.co.uk/pages/new-release/LA26EST_AMG.jpg',
  LA26EST_AMG_MB:
    'https://cdn.platex.co.uk/pages/new-release/LA26EST_AMG_MB.jpg',

  // 75
  HOTSHOT_URUS: 'https://cdn.platex.co.uk/pages/new-release/HOTSHOT_URUS.png',
  HOTSHOT_URUS_MB:
    'https://cdn.platex.co.uk/pages/new-release/HOTSHOT_URUS_MB.png',

  // 76 — bundled asset (1536x1024 PNG); same file serves desktop + mobile so the
  // banner-image component falls through the mobile path to the same source.
  HEMI_76: '/assets/hero/76.png',
  HEMI_76_MB: '/assets/hero/76.png',

  // LP
  SEARCH_918_DT: 'https://cdn.platex.co.uk/banners/SEARCH_PORSCHE_918_DT.png',
  SEARCH_918_MB: 'https://cdn.platex.co.uk/banners/SEARCH_PORSCHE_918_MB.png',
  XMAS_SEARCH_918_DT:
    'https://cdn.platex.co.uk/banners/CHRISTMAS_SEARCH_PORSCHE_918_DT.png',
  XMAS_SEARCH_918_MB:
    'https://cdn.platex.co.uk/banners/CHRISTMAS_SEARCH_PORSCHE_918_MB.png',
  SELL_TURBO_DT: 'https://cdn.platex.co.uk/banners/SELL_TURBO_DT.png',
  SELL_TURBO_MB: 'https://cdn.platex.co.uk/banners/SELL_TURBO_MB.png',
  HATE_TAX_DIABLO_DT: 'https://cdn.platex.co.uk/banners/HATE_TAX_DIABLO_DT.png',
  HATE_TAX_DIABLO_MB: 'https://cdn.platex.co.uk/banners/HATE_TAX_DIABLO_MB.png',

  SUB_200_DT: 'https://cdn.platex.co.uk/banners/SUB_200_FIAT_500_DT.png',
  SUB_200_MB: 'https://cdn.platex.co.uk/banners/SUB_200_FIAT_500_MB.png',
  NUM_1_DT: 'https://cdn.platex.co.uk/banners/NUM_1_DBS_DT.png',
  NUM_1_MB: 'https://cdn.platex.co.uk/banners/NUM_1_DBS_MB.png',
  FACTS_TESTAROSSA_DT:
    'https://cdn.platex.co.uk/banners/FACTS_TESTAROSSA_DT.png',
  FACTS_TESTAROSSA_MB:
    'https://cdn.platex.co.uk/banners/FACTS_TESTAROSSA_MB.png',

  DESIGNS_Z4: 'https://cdn.platex.co.uk/pages/new-release/DESIGNS_Z4.png',
  GEORGES_CGT: 'https://cdn.platex.co.uk/pages/new-release/GEORGES_CGT.png',
  RUSRELL_RS3: 'https://cdn.platex.co.uk/pages/new-release/RUSRELL_RS3.png',
  WHOEVER_CYBERTRUCK:
    'https://cdn.platex.co.uk/pages/new-release/WHOEVER_CYBERTRUCK.png',
  ARSENAL_ALPINE:
    'https://cdn.platex.co.uk/pages/new-release/ARSENAL_ALPINE.png',
  SLOANES_BENTLEY:
    'https://cdn.platex.co.uk/pages/new-release/SLOANES_BENTLEY.png',
  LASANGE_FERRARI:
    'https://cdn.platex.co.uk/pages/new-release/LASANGE_FERRARI.png',
  GHOSTED_BMW: 'https://cdn.platex.co.uk/pages/new-release/GHOSTED_BMW.png',
  MASSAGE_FIAT500:
    'https://cdn.platex.co.uk/pages/new-release/MASSAGE_FIAT500.png',
  HASGAME_URUS: 'https://cdn.platex.co.uk/pages/new-release/HASGAME_URUS.png',
  BLOGGER_MINI: 'https://cdn.platex.co.uk/pages/new-release/BLOGGER_MINI.png',
  SHOTGUN_DEFENDER:
    'https://cdn.platex.co.uk/pages/new-release/SHOTGUN_DEFENDER.png',
  FASTEST_LAFERRARI:
    'https://cdn.platex.co.uk/pages/new-release/FASTEST_LAFERRARI.png',
  PROBLEM_6X6: 'https://cdn.platex.co.uk/pages/new-release/PROBLEM_6X6.png',
  HUSBAND_I8: 'https://cdn.platex.co.uk/pages/new-release/HUSBAND_I8.png',
  VLOGGER_DEFENDER:
    'https://cdn.platex.co.uk/pages/new-release/VLOGGER_DEFENDER.png',
  BELOVED_R8: 'https://cdn.platex.co.uk/pages/new-release/BELOVED_R8.png',
  UNGODLY_AMG: 'https://cdn.platex.co.uk/pages/new-release/UNGODLY_AMG.png',
  BALLERS_URUS: 'https://cdn.platex.co.uk/pages/new-release/BALLERS_URUS.png',
  EMIRATE_ROLLS: 'https://cdn.platex.co.uk/pages/new-release/EMIRATE_ROLLS.png',
  FRIENDS_MINI: 'https://cdn.platex.co.uk/pages/new-release/FRIENDS_MINI.png',
  GELATOS_FIAT500:
    'https://cdn.platex.co.uk/pages/new-release/GELATOS_FIAT500.png',
  BRISTOL_I8: 'https://cdn.platex.co.uk/pages/new-release/BRISTOL_I8.png',
  FLIGHTS_PORSCHE:
    'https://cdn.platex.co.uk/pages/new-release/FLIGHTS_PORSCHE.png',
};
